import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Cell,
} from 'recharts';
import ChartTitle from '../../../../../elements/ChartTitle';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';

const BrokenSprintsChart = ({ data, loading, isJiraIntegrated }) => {
  const [chartData, setChartData] = useState([]);
  const [brokenCount, setBrokenCount] = useState(0);
  const [totalSprints, setTotalSprints] = useState(0);

  useEffect(() => {
    if (!data?.length) {
      setChartData([]);
      setBrokenCount(0);
      setTotalSprints(0);
      return;
    }

    const processed = data.map((sprint, index) => {
      const committed = sprint.totalStoryPoints || 0;
      const completed = sprint.completedStoryPoints || 0;
      const deliveryPercent = committed > 0 ? (completed / committed) * 100 : 0;
      const broken = deliveryPercent < 80;

      return {
        sprint: sprint.sprintName || `Sprint ${index + 1}`,
        deliveryPercent: +deliveryPercent.toFixed(2),
        broken,
      };
    });

    const brokenSprints = processed.filter((s) => s.broken).length;

    setChartData(processed);
    setBrokenCount(brokenSprints);
    setTotalSprints(processed.length);
  }, [data]);

  const summary = `${brokenCount} of ${totalSprints} sprint${
    totalSprints !== 1 ? 's' : ''
  } were broken (${
    totalSprints ? Math.round((brokenCount / totalSprints) * 100) : 0
  }%)`;

  return (
    <div className="chart-div">
      <ChartTitle title="Broken Sprints" subtitle={summary} showWarning={!isJiraIntegrated} />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            barSize={30}
            margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="sprint" tick={{ fontSize: 12 }} />
            <YAxis unit="%" domain={[0, 100]} />
            <Tooltip formatter={(value, name) => [`${Math.round(value)}%`, name]} />
            <Bar
              dataKey="deliveryPercent"
              name="Delivered"
              isAnimationActive={false}>
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.broken ? '#B22222' : '#008000'}
                />
              ))}
            </Bar>
            <ReferenceLine
              y={80}
              stroke="#000000"
              strokeDasharray="3 3"
              label={{
                value: '80% Threshold',
                position: 'top',
                fontSize: 12,
                fill: '#000000',
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default BrokenSprintsChart;
